/* shared-customer-checkout-router; store=vape-amazon */
(() => {
  const checkoutUrl = "https://orrohub.in/pg/manual-checkout.php";
  const storeKey = "vape-amazon";
  let opening = false;

  const rootPath = () => window.Shopify?.routes?.root || '/';
  const isCheckoutButton = (element) => {
    if (!element) return false;
    return element.matches([
      'button[name="checkout"]',
      'input[name="checkout"]',
      '#checkout',
      '#CartDrawer-Checkout',
      '[data-manual-checkout]',
      '[data-cart-checkout-button]'
    ].join(','));
  };
  const isBuyNowButton = (element) => {
    if (!element) return false;
    if (element.matches('.shopify-payment-button__button, [data-buy-now], [data-buy-it-now], [name="buy-now"]')) return true;
    const text = String(element.textContent || element.value || '').trim().toLowerCase();
    return /^buy(?: it)? now$/.test(text);
  };
  const selectedProductLine = (button) => {
    const form = button.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    if (!form) return null;
    const formData = new FormData(form);
    const id = Number(formData.get('id'));
    const quantity = Math.max(1, Number(formData.get('quantity') || 1));
    return Number.isFinite(id) && id > 0 ? { id, quantity } : null;
  };
  const openCheckout = (lines) => {
    if (!Array.isArray(lines) || lines.length === 0) {
      window.location.assign(rootPath() + 'cart');
      return;
    }
    const form = document.createElement('form');
    form.method = 'post';
    form.action = checkoutUrl;
    form.hidden = true;
    const append = (name, value) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = String(value);
      form.appendChild(input);
    };
    append('action', 'start');
    append('store', storeKey);
    lines.forEach((line) => {
      append('line_id[]', line.id);
      append('line_quantity[]', line.quantity);
    });
    document.body.appendChild(form);
    form.submit();
  };
  const readCartLines = async () => {
    const response = await fetch(rootPath() + 'cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    });
    if (!response.ok) throw new Error('Unable to refresh the cart.');
    const cart = await response.json();
    return (cart.items || [])
      .map((item) => ({ id: Number(item.variant_id || item.id), quantity: Number(item.quantity) }))
      .filter((line) => line.id > 0 && line.quantity > 0);
  };
  const addProductThenCheckout = async (line) => {
    const response = await fetch(rootPath() + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [line] })
    });
    if (!response.ok) throw new Error('Unable to add this product to the cart.');
    openCheckout(await readCartLines());
  };
  const setBusy = (button, busy) => {
    if (busy) {
      button.dataset.checkoutOriginalLabel = button.textContent || button.value || '';
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      if ('textContent' in button && button.tagName !== 'INPUT') button.textContent = 'Opening secure checkout…';
    } else {
      button.removeAttribute('aria-busy');
      button.disabled = false;
      if (button.dataset.checkoutOriginalLabel && button.tagName !== 'INPUT') button.textContent = button.dataset.checkoutOriginalLabel;
    }
  };
  document.addEventListener('click', async (event) => {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    const button = target?.closest('button, input, a, [role="button"]');
    const checkout = isCheckoutButton(button);
    const buyNow = !checkout && isBuyNowButton(button);
    if ((!checkout && !buyNow) || opening || button?.disabled) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    opening = true;
    setBusy(button, true);
    try {
      if (buyNow) {
        const line = selectedProductLine(button);
        if (!line) throw new Error('Select a product option before continuing.');
        await addProductThenCheckout(line);
      } else {
        openCheckout(await readCartLines());
      }
    } catch (error) {
      opening = false;
      setBusy(button, false);
      const errorBox = document.querySelector('#cart-errors, [data-cart-errors], .cart__errors');
      if (errorBox) errorBox.textContent = error instanceof Error ? error.message : 'Please reload the page and try again.';
    }
  }, true);
})();
